import React from 'react';
import { Instant } from '../../utility/datetime';
const KEY = 'crm_dev_scheduling';
const CHANGED_EVENT = 'crm-scheduling-changed';
export const PUBLIC_BOOKING_BASE = 'https://book.rateremover.com';
export const DAY_LABELS = {
    'mon': 'Monday',
    'tue': 'Tuesday',
    'wed': 'Wednesday',
    'thu': 'Thursday',
    'fri': 'Friday',
    'sat': 'Saturday',
    'sun': 'Sunday',
};
export const DAY_ORDER = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
const SEED = {
    'business_hours': [
        { 'day': 'mon', 'closed': false, 'open_time': '08:00', 'close_time': '17:00' },
        { 'day': 'tue', 'closed': false, 'open_time': '08:00', 'close_time': '17:00' },
        { 'day': 'wed', 'closed': false, 'open_time': '08:00', 'close_time': '17:00' },
        { 'day': 'thu', 'closed': false, 'open_time': '08:00', 'close_time': '17:00' },
        { 'day': 'fri', 'closed': false, 'open_time': '08:00', 'close_time': '17:00' },
        { 'day': 'sat', 'closed': false, 'open_time': '09:00', 'close_time': '13:00' },
        { 'day': 'sun', 'closed': true, 'open_time': '09:00', 'close_time': '13:00' },
    ],
    'appointment_types': [
        { 'id': 'at1', 'name': 'Oil Change', 'duration_minutes': 30, 'description': 'Standard oil and filter change.' },
        { 'id': 'at2', 'name': 'Multi-Point Inspection', 'duration_minutes': 60, 'description': 'Comprehensive vehicle inspection.' },
        { 'id': 'at3', 'name': 'Brake Service', 'duration_minutes': 120, 'description': 'Brake pad / rotor work.' },
        { 'id': 'at4', 'name': 'Drop-Off', 'duration_minutes': 15, 'description': 'Quick check-in for longer repairs.' },
    ],
    'blocked_dates': [],
    'booking_slug': 'sample-business',
};
const readConfig = () => {
    const raw = localStorage.getItem(KEY);
    if (!raw) {
        return SEED;
    }
    try {
        return JSON.parse(raw);
    }
    catch (_a) {
        return SEED;
    }
};
const writeConfig = (cfg) => {
    localStorage.setItem(KEY, JSON.stringify(cfg));
    window.dispatchEvent(new CustomEvent(CHANGED_EVENT));
};
export const useSchedulingConfig = () => {
    const [cfg, setCfg] = React.useState(readConfig);
    React.useEffect(() => {
        const onChange = () => setCfg(readConfig());
        window.addEventListener(CHANGED_EVENT, onChange);
        return () => window.removeEventListener(CHANGED_EVENT, onChange);
    }, []);
    return cfg;
};
export const updateConfig = (patch) => {
    const cur = readConfig();
    writeConfig(Object.assign(Object.assign({}, cur), patch));
};
export const updateDayHours = (day, patch) => {
    const cur = readConfig();
    const next = Object.assign(Object.assign({}, cur), { 'business_hours': cur.business_hours.map((h) => h.day === day ? Object.assign(Object.assign({}, h), patch) : h) });
    writeConfig(next);
};
const newId = () => `${Instant.now().toEpochMilli().toString(36)}_${Math.random().toString(36).slice(2, 6)}`;
export const addAppointmentType = (name, duration_minutes, description) => {
    const cur = readConfig();
    const at = { 'id': newId(), 'name': name, 'duration_minutes': duration_minutes, 'description': description };
    writeConfig(Object.assign(Object.assign({}, cur), { 'appointment_types': [...cur.appointment_types, at] }));
};
export const updateAppointmentType = (id, patch) => {
    const cur = readConfig();
    const next = cur.appointment_types.map((a) => a.id === id ? Object.assign(Object.assign({}, a), patch) : a);
    writeConfig(Object.assign(Object.assign({}, cur), { 'appointment_types': next }));
};
export const removeAppointmentType = (id) => {
    const cur = readConfig();
    writeConfig(Object.assign(Object.assign({}, cur), { 'appointment_types': cur.appointment_types.filter((a) => a.id !== id) }));
};
export const addBlockedDate = (date, reason) => {
    const cur = readConfig();
    const bd = { 'id': newId(), 'date': date, 'reason': reason };
    writeConfig(Object.assign(Object.assign({}, cur), { 'blocked_dates': [...cur.blocked_dates, bd] }));
};
export const removeBlockedDate = (id) => {
    const cur = readConfig();
    writeConfig(Object.assign(Object.assign({}, cur), { 'blocked_dates': cur.blocked_dates.filter((b) => b.id !== id) }));
};
export const publicBookingUrl = (slug) => `${PUBLIC_BOOKING_BASE}/${slug}`;
export const embedSnippet = (slug) => `<iframe src="${publicBookingUrl(slug)}" width="100%" height="700" frameborder="0" style="border:0;"></iframe>`;
